import { useCallback } from 'react';
import { rage, useObservable } from '~/rage';
import {
	IModalReplyDefault,
	LootBuyerType,
	ModalButtonColor,
	ModalType,
	WalletType,
} from '~/shared';

const useSell = () => {
	const currentLootBuyerType = useObservable(
		rage.lootBuyers.getCurrentLootBuyerType(),
	);

	const handleSell = useCallback(
		(
			name: string,
			lootBuyerType: LootBuyerType,
			itemId: string,
			itemCount: number,
			price: number,
		) => {
			if (!currentLootBuyerType) return;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: `Вы действительно хотите продать ${name} ${itemCount} шт.?`,
					price: price,
					wallet: WalletType.Cash,
					acceptButton: { text: 'Продать', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result: IModalReplyDefault) => {
					if (result.isAccepted) {
						rage.lootBuyers.sellItem(lootBuyerType, itemId);
					}
				},
			);
		},
		[currentLootBuyerType],
	);

	const handleSellAll = useCallback(
		(price: number) => {
			if (!currentLootBuyerType) return;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: `Вы действительно хотите продать всю рыбу?`,
					price: price,
					wallet: WalletType.Cash,
					acceptButton: { text: 'Продать', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result: IModalReplyDefault) => {
					if (result.isAccepted) {
						rage.lootBuyers.sellAllItems(currentLootBuyerType);
					}
				},
			);
		},
		[currentLootBuyerType],
	);

	return { handleSell, handleSellAll };
};

export { useSell };
